import { createDynamicSlice } from ".";
import { AddInventory, GetCancellationPolicy, GetInventoryDetails, GetReturnPolicy, GetSuppliers, SaveCancellationPolicy, SaveReturnPolicy, UpdateCancellationPolicy, UpdateInventory, UpdateReturnPolicy, vendorStoresThunk } from "../thunks/vendorStoreThunk";


const vendorStoresSlice = createDynamicSlice({
  name: "vendorStoresSlice",
  thunk: vendorStoresThunk,
});

const inventoryDetailsSlice = createDynamicSlice({
  name: "inventoryDetailsSlice",
  thunk: GetInventoryDetails,
});

const addInventorySlice = createDynamicSlice({
  name: "addInventorySlice",
  thunk: AddInventory,
  resetActionName: "resetAddInventory",
});

const updateInventorySlice = createDynamicSlice({
  name: "updateInventorySlice",
  thunk: UpdateInventory,
  resetActionName: "resetUpdateInventory",
});

const returnPolicySlice = createDynamicSlice({
  name: "returnPolicySlice",
  thunk: GetReturnPolicy,
});

const cancellationPolicySlice = createDynamicSlice({
  name: "cancellationPolicySlice",
  thunk: GetCancellationPolicy,
});

const suppliersSlice = createDynamicSlice({
  name: "suppliersSlice",
  thunk: GetSuppliers,
});

const updateReturnPolicySlice = createDynamicSlice({
  name: "updateReturnPolicySlice",
  thunk: UpdateReturnPolicy,
  resetActionName: "resetUpdateReturn"
});

const saveReturnPolicySlice = createDynamicSlice({
  name: "saveReturnPolicySlice",
  thunk: SaveReturnPolicy,
  resetActionName: "resetSaveReturn"
})

const updateCancellationPolicySlice = createDynamicSlice({
  name: "updateCancellationPolicySlice",
  thunk: UpdateCancellationPolicy,
  resetActionName: "resetUpdateCancellation"
});

const saveCancellationPolicySlice = createDynamicSlice({
  name: "saveCancellationPolicySlice",
  thunk: SaveCancellationPolicy,
  resetActionName: "resetSaveCancellation"
})

export const vendorStoresReducer = vendorStoresSlice.reducer;
export const inventoryDetailsReducer = inventoryDetailsSlice.reducer;
export const returnPolicyReducer = returnPolicySlice.reducer;
export const cancellationPolicyReducer = cancellationPolicySlice.reducer;
export const suppliersReducer = suppliersSlice.reducer;
export const updateReturnPolicyReducer = updateReturnPolicySlice.reducer;
export const updateCancellationPolicyReducer = updateCancellationPolicySlice.reducer;
export const addInventoryReducer = addInventorySlice.reducer;
export const updateInventoryReducer = updateInventorySlice.reducer;
export const saveCancellationPolicyReducer = saveCancellationPolicySlice.reducer;
export const saveReturnPolicyReducer = saveReturnPolicySlice.reducer;

// export const { resetAction: resetVendorStores } = vendorStoresSlice;
// export const { resetAction: resetInventoryDetails } = inventoryDetailsSlice;
// export const { resetAction: resetReturnPolicy } = returnPolicySlice;
// export const { resetAction: resetCancellationPolicy } = cancellationPolicySlice;
// export const { resetAction: resetSuppliers } = suppliersSlice;
// export const { resetAction: resetUpdateReturnPolicy } = updateReturnPolicySlice;
export const { resetUpdateCancellation} = updateCancellationPolicySlice.actions;
export const {resetSaveCancellation} = saveCancellationPolicySlice.actions;
export const {resetUpdateReturn} = updateReturnPolicySlice.actions;
export const { resetAddInventory } = addInventorySlice.actions;
export const { resetUpdateInventory } = updateInventorySlice.actions;    
export const {resetSaveReturn} = saveReturnPolicySlice.actions;